import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  card: {
    width: '100%'
  },
  cardContent: {
    '&:last-child': {
      paddingBottom: 16
    }
  },
  divider: {
    paddingTop: 8,
    paddingBottom: 8
  },
  checkbox: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    marginTop: 'auto',
    marginBottom: 'auto',
    cursor: 'pointer'
  },
  checkboxLabel: {
    position: 'static'
  }
}))
